import React from 'react';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { MenuItem, StylesProvider } from '@material-ui/core';
import MuiMenu from '@material-ui/core/Menu';

interface IMenuDropdownProps {
  menuId: number;
  label: string;
  menuItems: any[];
  handleNavigate: (url: string, target: string, menuId: number) => void;
  current: any;
  contentLayout: any;
}

export function MenuDropdown({ menuId, label, menuItems, handleNavigate, current, contentLayout }: IMenuDropdownProps) {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <div
        id={'menu-dropdown-button' + menuId}
        className="cms-menu-item flex items-center cursor-pointer"
        aria-controls={open ? 'menu-dropdown' + menuId : undefined}
        aria-expanded={open ? 'true' : undefined}
        aria-haspopup="true"
        onClick={handleClick}
      >
        <span>{label}</span>
        <ExpandMoreIcon className="ml-1.5" />
      </div>

      <MuiMenu
        id={'menu-dropdown' + menuId}
        MenuListProps={{ className: 'cms-menu-list', 'aria-labelledby': 'menu-dropdown-button' + menuId }}
        className="menu-items translate-y-8"
        anchorEl={anchorEl}
        keepMounted
        open={!!anchorEl}
        onClose={handleClose}
      >
        {menuItems
          ?.filter(menuItem => menuItem.parentMenuId === menuId)
          ?.map(menuItem => {
            if (menuItem?.url?.startsWith('#')) {
              return (
                <MenuItem key={menuItem?.menuId} className='!p-0'
                  onClick={() => {
                    handleClose();
                  }}
                >
                  <a href={menuItem?.url} 
                   className={`cms-menu-item no-underline text-inherit w-full h-full py-1.5 px-3.5 ${
                    (current?.scopedLayout ? current?.scopedLayout?.layoutCode === menuItem.layoutCode : contentLayout.layoutCode === menuItem.layoutCode)
                      ? 'active'
                      : ''
                  }`}
                  >
                    {menuItem.label}
                  </a>
                </MenuItem>
              );
            }

            return (
              <MenuItem key={menuItem?.menuId} 
                onClick={() => {
                  handleClose();
                  handleNavigate(menuItem.url, menuItem.target, menuId);
                }}
              >
                <div
                  className={`cms-menu-item  ${
                    (current?.scopedLayout ? current?.scopedLayout?.layoutCode === menuItem.layoutCode : contentLayout.layoutCode === menuItem.layoutCode)
                      ? 'active'
                      : ''
                  }`}
                >
                  {menuItem.label}
                </div>
              </MenuItem>
            );
          })}
      </MuiMenu>
    </div>
  );
}
